export const PAGE_TITLES = {
  '/dashboard': 'dashboard',
  '/tasks/live-activity': 'live-activity',
  '/tasks/configurations': 'configurations',
  '/tasks/configurations/alerts': 'configurations',
  '/tasks/configurations/events': 'configurations',
  '/balances/balances': 'actual-balances',
  '/balances/positions': 'positions',
  '/balances/margins': 'margins',
  '/balances/computed-balances': 'computed-balances',
  '/defi/balances': 'Balances',
  '/defi/subscription-redemption': 'Subscription & Redemption',
  '/defi/performance': 'Performance',
  '/risk/risk': 'risk',
  '/risk/stress-test': 'scenarios',
  '/performance/pnl-breakdown': 'pnl-breakdown',
  '/performance/performance-analysis': 'performance-analysis',
  '/performance/history-pnl': 'historical-pnl',
  '/operations/transactions': 'transactions',
  '/operations/reconciliation': 'Reconciliation',
  '/operations/settlement': 'settlement',
  '/operations/settlement/:portfolioId': 'settlement',
  '/operations/settlement/:portfolioId/policy': 'settlement',
  '/operations/settlement/:portfolioId/details/:recordId': 'settlement-details',
  '/lms/credit-agreements': 'credit-agreements',
  '/lms/tranches': 'tranches',
  '/reports-new': 'reports',
  '/reports-new/create': 'Create Report',
  '/prices/prices': 'currencies',
  '/prices/derivatives-prices': 'derivatives-prices',
  '/prices/funding-rates': 'funding-rates',
  '/settings/portfolios': 'portfolios',
  '/settings/link-management': 'link-management',
  '/settings/user-permissions': 'user-permissions',
  '/settings/user-permissions/roles': 'user-permissions',
  '/settings/user-permissions/users': 'user-permissions',
  '/settings/historicalaum': 'historicalaum',
  '/settings/liquidity-tiers': 'liquidity-tiers',
  '/settings/configurations': 'configurations',
  '/reports': 'reports',
}
